<template>
  <div class="container">
    <div class="inside-banner">
      <!-- ElementUI轮播图 -->
      <el-carousel
          class="banner-carousel"
          indicator-position="none"
          loop
          autoplay
          arrow="never"
      >
        <el-carousel-item v-for="(item, index) in bannerImgList" :key="index">
          <img
              :src="item.src"
              :alt="item.title || '常见问题轮播图'"
              class="carousel-img"
          />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="service-content">
      <div class="service-nav">
        <a href="/portal_check?type=check" target="">真伪查询</a>
        <a href="/portal_check?type=sales" target="">售后流程</a>
        <a class="on" href="" target="">常见问题</a>
        <a href="/portal_check?type=wh" target="">使用维护</a>
      </div>
      <div class="service-box service-wt">
        <ul>
          <li v-for="(item, index) in articleList" :key="index">
            <a @click="handNewsList(item.id)">
              <h3 class="nowrap">{{ item.title }}</h3>
              <p>{{item.intro}}</p>
              <img :src="item.thumbnail" :alt="item.title">
            </a>
          </li>
        </ul>
        <a class="view-more" :href="`/articleHome?articleType=${NodeIdEnum.ARTICLE_TYPE_CJWT_ID.value}`" target="_blank">查看更多<i class="fa fa-angle-double-right"></i></a>
      </div>
    </div>
  </div>
</template>

<script>
import {getImgList, selectArticleList} from "@/api/home";
import {ImageTypeEnum} from "@/enums/imageTypeEnum";
import {NodeIdEnum} from "@/enums/nodeIdEnum";

export default {
  computed: {
    NodeIdEnum() {
      return NodeIdEnum
    }
  },
  data() {
    return {
      bannerImgList: [], //顶部banner图
      articleList:[],//文章列表
      loading: false // 补充loading初始化，避免控制台警告
    }
  },
  created() {
    this.getBannerList();
    this.fetchArticleList();
  },
  methods: {
    //获取图片
    async getBannerList() {
      try {
        this.loading = true;
        const res = await getImgList(ImageTypeEnum.CHECK_34_BANNER.value);
        const dataList = res.data || [];
        this.bannerImgList = dataList.filter(item => item.classify === ImageTypeEnum.CHECK_34_BANNER.value && item.src);
      } catch (error) {
        console.error("获取轮播图失败：", error);
        this.$message?.error("轮播图加载失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },
    async fetchArticleList() {
      try { // 增加try-catch捕获异常
        const res = await selectArticleList(NodeIdEnum.ARTICLE_TYPE_CJWT_ID.value, 1, 10);
        if (res.code === 200) {
          this.articleList = res.data.rows || [];
        } else {
          this.$message.error(res.msg || "获取文章列表失败");
        }
      } catch (error) {
        console.error("获取常见问题列表失败：", error);
        this.$message.error("获取常见问题列表失败，请稍后重试");
      }
    },
    //相关新闻点击事件
    handNewsList(id){
      this.$router.push({ path: '/article', query: { articleId: id, type:NodeIdEnum.ARTICLE_TYPE_CJWT_ID.value } });
    },
  }
}
</script>

<style scoped lang="scss">
.container {
  position: relative;
  width: 100%;
  max-width: 1920px; // 限制最大宽度，避免大屏拉伸
  margin: 0 auto;
  box-sizing: border-box;
  padding: 0 15px; // 移动端增加左右内边距，防止内容贴边
}

// Banner容器
.inside-banner {
  position: relative;
  margin-top: 100px;
  width: 100%;
  overflow: hidden;

  // 平板适配 (768px以下)
  @media (max-width: 768px) {
    margin-top: 80px;
  }
  // 手机适配 (480px以下)
  @media (max-width: 480px) {
    margin-top: 60px;
  }
}

// ElementUI轮播图容器样式
.banner-carousel {
  width: 100%;
  height: 880px !important;

  // 平板适配
  @media (max-width: 768px) {
    height: 400px !important; // 优化平板端高度，视觉更协调
  }
  // 手机适配（使用vw单位，适配不同屏幕宽度）
  @media (max-width: 480px) {
    height: 50vw !important;
    max-height: 300px; // 限制最大高度，避免小屏过高
  }

  :deep(.el-carousel__container) {
    height: 100%;
  }

  :deep(.el-carousel-item) {
    height: 100%;
  }
}

// 轮播图图片样式
.carousel-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  // 移动端优化图片显示
  @media (max-width: 480px) {
    object-fit: contain;
    background: #f5f5f5;
  }
}

.service-nav {
  text-align: center;
  background: #fff;
  padding: 0 10px; // 增加内边距，防止按钮贴边
  box-sizing: border-box;

  // 平板适配
  @media (max-width: 768px) {
    padding: 0 5px;
  }

  // 手机适配
  @media (max-width: 480px) {
    padding: 0;
  }

  a, span {
    color: #222;
    display: inline-block;
    vertical-align: top;
    width: 12%;
    height: 50px;
    margin: 50px 1%;
    text-align: center;
    line-height: 48px;
    font-size: 18px;
    border: 1px solid #666;
    cursor: pointer;
    border-radius: 6px;
    box-sizing: border-box; // 确保边框不影响宽度计算
    text-decoration: none; // 去除链接下划线

    // 平板适配
    @media (max-width: 768px) {
      width: 22%; // 调整宽度，适配平板
      margin: 30px 1%;
      height: 45px;
      line-height: 43px;
      font-size: 16px;
    }

    // 手机适配
    @media (max-width: 480px) {
      width: 46%; // 改为两行显示，提升触控体验
      margin: 15px 2%;
      height: 40px;
      line-height: 38px;
      font-size: 14px;
    }
  }

  .on {
    background: #d26b6b;
    color: #fff;
    border-color: #d26b6b;
  }
}

.service-nav-fixed {
  z-index: 666;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  max-width: none;
  box-shadow: 0 0 8px rgba(0,0,0,.1);
  padding: 0 10px; // 增加内边距

  a, span {
    height: 36px;
    line-height: 36px;
    margin: 15px 1%;
    font-size: 16px;

    // 手机适配
    @media (max-width: 480px) {
      height: 32px;
      line-height: 30px;
      margin: 10px 2%;
      font-size: 13px;
    }
  }
}

.service-box {
  padding: 50px 0;
  background: #f6f6f6;
  box-sizing: border-box;

  // 平板适配
  @media (max-width: 768px) {
    padding: 30px 0;
  }

  // 手机适配
  @media (max-width: 480px) {
    padding: 20px 0;
  }
}

// 修复重复定义的样式，合并为统一适配
.service-wt {
  padding: 50px 15px; // 增加左右内边距
  background: #f6f6f6;
  box-sizing: border-box;

  // 平板适配
  @media (max-width: 768px) {
    padding: 30px 10px;
  }

  // 手机适配
  @media (max-width: 480px) {
    padding: 20px 10px;
  }

  ul {
    overflow: hidden;
    list-style: none;
    padding: 0; // 重置ul默认内边距
    margin: 0; // 重置ul默认外边距
    width: 100%;

    li {
      float: left;
      width: 25%;
      padding: 0 1.5%;
      margin-bottom: 30px;
      box-sizing: border-box;

      // 平板适配 - 改为2列布局
      @media (max-width: 768px) {
        width: 47%;
        padding: 0 1.5%;
        margin-bottom: 20px;
      }

      // 手机适配 - 改为1列布局
      @media (max-width: 480px) {
        width: 100%;
        padding: 0;
        margin-bottom: 20px;
      }

      a {
        display: block;
        background: #fff;
        text-decoration: none; // 去除链接下划线
        border-radius: 4px; // 增加圆角，提升视觉体验
        box-shadow: 0 2px 4px rgba(0,0,0,0.05); // 增加轻微阴影

        // 手机适配
        @media (max-width: 480px) {
          padding: 0 10px;
        }
      }

      h3 {
        padding: 15px 20px;
        font-size: 18px;
        color: #222;
        font-weight: normal;
        margin: 0; // 重置默认margin
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis; // 文字超出显示省略号

        // 平板适配
        @media (max-width: 768px) {
          padding: 12px 15px;
          font-size: 16px;
        }

        // 手机适配
        @media (max-width: 480px) {
          padding: 10px 15px;
          font-size: 15px;
        }
      }

      p {
        height: 64px;
        margin-bottom: 30px;
        padding: 0 20px;
        line-height: 22px;
        color: #999;
        overflow: hidden;
        margin-top: 0; // 重置默认margin

        // 平板适配
        @media (max-width: 768px) {
          height: 56px;
          margin-bottom: 20px;
          padding: 0 15px;
          line-height: 20px;
          font-size: 14px;
        }

        // 手机适配
        @media (max-width: 480px) {
          height: auto; // 取消固定高度，自适应
          margin-bottom: 15px;
          padding: 0 15px;
          line-height: 20px;
          font-size: 13px;
        }
      }

      img {
        width: 100%;
        display: block; // 去除图片底部空白
        border-radius: 0 0 4px 4px; // 图片底部圆角

        // 手机适配
        @media (max-width: 480px) {
          max-height: 200px; // 限制图片最大高度
          object-fit: cover; // 保持图片比例
        }
      }
    }
  }

  .view-more {
    display: block;
    width: 145px;
    height: 45px;
    margin: 0 auto;
    margin-top: 30px;
    font-size: 16px;
    color: #fff;
    text-align: center;
    line-height: 45px;
    background: #d26b6b;
    border-radius: 3px;
    text-decoration: none; // 去除链接下划线

    // 平板适配
    @media (max-width: 768px) {
      width: 130px;
      height: 40px;
      line-height: 40px;
      font-size: 15px;
      margin-top: 20px;
    }

    // 手机适配
    @media (max-width: 480px) {
      width: 120px;
      height: 38px;
      line-height: 38px;
      font-size: 14px;
      margin-top: 10px;
    }

    i {
      margin-left: 6px;
      font-size: 18px;
      color: #fff;

      // 平板/手机适配
      @media (max-width: 768px) {
        font-size: 16px;
        margin-left: 5px;
      }
    }
  }
}
</style>